<template>
  <span
    v-if="icon"
    class="material-icons"
    :class="iconClass"
  >
    {{ icon }}
  </span>
</template>

<script>
export default {
  name: 'm-icon',
  props: {
    icon: {
      type: [String, Boolean],
      default: null,
    },
    size: {
      type: String,
      default: 'medium' //small medium large x-large
    },
    color: {
      type: String,
      default: 'white' // primary black white
    },
    inactive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      return [
        this.inactive && 'inactive',
        `${this.size}`,
        `${this.color}`
      ]
    },
  },
}
</script>
